import { LazyLoadingSectionLogger, LoggingSection } from "@multiweb/logging";
import { IndexedDBPromise } from "../../IndexedDB/Promises/IndexedDBPromise";
import { IClassDescriptionCache, IClassDescriptionDbCache } from "../Remoting/Cache/ClassDescriptionCache/IClassDescriptionCache";
import { AttributeDescriptionDbManager } from "./AttributeDescriptionDbManager";
import { IndexedDbManager } from "./IndexedDbManager";

const logger = LazyLoadingSectionLogger.create(LoggingSection.modelDescription);

export class ClassDescriptionDbManager extends IndexedDbManager {
    constructor(storageVersion: number = 1) {
        super("ClassData", storageVersion);
        this.registerStore("OWRemoting.SWModelsDescriptionStorage");
    }

    protected override _getKeyPath(): string {
        return "className";
    }

    public async getValues(className: string): Promise<IClassDescriptionDbCache> {
        const db = await this._storageDb;

        return IndexedDBPromise.getRowsByIndexValues(db, this._storeNames[0], [className]);
    }

    public async setValues(data: IClassDescriptionCache[]): Promise<void> {
        try {
            const db = await this._storageDb;
            const store = db.transaction(this._storeNames, "readwrite").objectStore(this._storeNames[0]);
            const attrDb = new AttributeDescriptionDbManager(this._databaseVersion);

            let excLogged = false;
            for (const li of data) {
                const lidb: IClassDescriptionCache = Object.assign({}, li);
                //delete lidb.Attributes;

                const dbObj: IClassDescriptionDbCache = {
                    className: lidb.ClassName,
                    serializedObject: JSON.stringify(lidb),
                };

                // uložení atributu do kešovací tabulky pro atributy
                // @ts-ignore
                await attrDb.setValues(lidb.ClassName, Array.from(li!.Attributes.values()).map((item) => {
                    item.CacheType = "ClassDescription"; return item;
                }));

                try {
                    store.put(dbObj);
                } catch (e) {
                    if (!excLogged) {
                        logger.error(e);
                        excLogged = true;
                    }
                }
            }
        } catch (ex) {
            logger.error(ex);
            logger.error(JSON.stringify(ex));
        }
    }
}
